import { RetroAnalysisLoss, AddRetroLoss, AddRetroLossParam } from '@serviceModels/AnalysisController';
import { Injectable } from '@angular/core';
import {ServiceLibrary, ServiceReturn} from '@common_libraries/helpers/ServiceLibrary';
import {Observable} from 'rxjs';
import {Dictionary} from '@common_libraries/helpers/Dictionary';
import {map} from 'rxjs/operators';
@Injectable({providedIn: 'root'})
export class AnalysisService {

  public constructor(private servLib: ServiceLibrary) {
  }

  GetAnalysisByID(id: number): Observable<ServiceReturn> {
    // don't need any params
    const parameters = new Dictionary([]);

    return this.servLib.HttpGet('/v1/api/AnalysisInternal/' + id, ServiceLibrary.ContentType.JSON, parameters, id);
  }

  AllowEdit(id: number): Observable<ServiceReturn> {
    // don't need any params
    const parameters = new Dictionary([]);

    return this.servLib.HttpGet('/v1/api/AnalysisInternal/' + id + '/allowed', ServiceLibrary.ContentType.JSON, parameters, id);
  }

  GetFilteredAnalysisPaged(params: Dictionary) {
    return this.servLib.HttpPost('/v1/api/AnalysisInternal/filter', ServiceLibrary.ContentType.JSON, params);
  }

  GetFilteredAnalysisByRetroPortfolioPaged(retroPortfolioID: number, archived: boolean, pageIndex: number, rowSize: number, sortColumn: string, sortDirection: string) {
    const parameters = new Dictionary([]);
    parameters.addOrUpdate('RetroPortfolioID', retroPortfolioID);
    parameters.addOrUpdate('Archived', archived);
    parameters.addOrUpdate('PageIndex', pageIndex);
    parameters.addOrUpdate('RowSize', rowSize);
    parameters.addOrUpdate('SortColumn', sortColumn);
    parameters.addOrUpdate('SortDirection', sortDirection);

    return this.servLib.HttpPost('/v1/api/AnalysisInternal/FilterByRetro', ServiceLibrary.ContentType.JSON, parameters);
  }

  GetAnalysisItems(id: number) {
    // don't need any params
    const parameters = new Dictionary([]);

    return this.servLib.HttpGet('/v1/api/AnalysisInternal/' + id.toString() + '/AnalysisItems', ServiceLibrary.ContentType.JSON, parameters, id);
  }

  GetRiskMeasureAnalysisItems(id: number) {
    // don't need any params
    const parameters = new Dictionary([]);

    return this.servLib.HttpGet('/v1/api/AnalysisInternal/' + id.toString() + '/RiskMeasureAnalysisItems', ServiceLibrary.ContentType.JSON, parameters, id);
  }

  GetRiskMeasureAnalysisItemsExistingOnRetroPortfolio(id: number) {
    // don't need any params
    const parameters = new Dictionary([]);

    return this.servLib.HttpGet('/v1/api/AnalysisInternal/' + id.toString() + '/RiskMeasureAnalysisItemsExistingOnRetroPortfolio', ServiceLibrary.ContentType.JSON, parameters, id);
  }

  GetAnalysisCCRMItems(id: number) {
    // don't need any params
    const parameters = new Dictionary([]);

    return this.servLib.HttpGet('/v1/api/AnalysisInternal/' + id.toString() + '/AnalysisCCRM', ServiceLibrary.ContentType.JSON, parameters, id);
  }

  CopyAnalysisItems(id: number, itemsToCopy: number[], copyRelationships: boolean) {
    const parameters = new Dictionary([]);
    parameters.add('AnalysisItemIDs', itemsToCopy);
    parameters.add('CopyRelationships', copyRelationships);

    return this.servLib.HttpPost('/v1/api/AnalysisInternal/' + id.toString() + '/AnalysisItem/Copy', ServiceLibrary.ContentType.JSON, parameters, id);
  }

  ApplyOverrides(id: number, parameters: any) {
    return this.servLib.HttpPost('/v1/api/AnalysisInternal/' + id.toString() + '/AnalysisItem/ApplyOverrides', ServiceLibrary.ContentType.JSON, parameters, id);
  }

  UpdateDisplayList(id: number, analysisItemIDs: any) {
    const parameters = new Dictionary([]);
    parameters.add('ItemRefs', analysisItemIDs);

    return this.servLib.HttpPost('/v1/api/AnalysisInternal/' + id.toString() + '/UpdateDisplayList', ServiceLibrary.ContentType.JSON, parameters, id);
  }

  PrepAnalysisItems(id: number, itemsToPrep: number[]) {
    const parameters = new Dictionary([]);
    parameters.add('AnalysisItemIDs', itemsToPrep);

    return this.servLib.HttpPost('/v1/api/AnalysisInternal/' + id.toString() + '/PrepAnalysis', ServiceLibrary.ContentType.JSON, parameters, id);
  }

  UnapplyRetroAnalysisItems(analysisID: number, retroPortfolioID: number, analysisItemIDs: number[]) {
    const parameters = new Dictionary([]);
    parameters.add('AnalysisItemIDs', analysisItemIDs);
    parameters.add('RetroPortfolioID', retroPortfolioID);

    return this.servLib.HttpPost('/v1/api/AnalysisInternal/' + analysisID + '/UnapplyRetroAnalysisItems', ServiceLibrary.ContentType.JSON, parameters, analysisID);
  }

  DeleteAnalysisItems(id: number, itemsToDelete: number[]) {
    const parameters = new Dictionary([]);
    parameters.add('AnalysisItemIDs', itemsToDelete);

    return this.servLib.HttpPost('/v1/api/AnalysisInternal/' + id.toString() + '/AnalysisItem/Delete', ServiceLibrary.ContentType.JSON, parameters, id);
  }

  CheckLossFileValid(lossAttrID: number, analysisID: number, analysisItemID: number, oldLossFileHasRIP: boolean) {
    const parameters = new Dictionary([]);

    return this.servLib.HttpPost('/v1/api/AnalysisInternal/' + analysisID.toString() + '/AnalysisItem/' + analysisItemID + '/' + lossAttrID + '/' + oldLossFileHasRIP + '/CheckLossFileValidity', ServiceLibrary.ContentType.JSON, parameters, analysisID);
  }

  AddAnalysisItemLossFile(LossFileIDList: number[], analysisID: number) {
    const parameters = new Dictionary([]);
    parameters.add('LossFileIDList', LossFileIDList);

    return this.servLib.HttpPost('/v1/api/AnalysisInternal/' + analysisID.toString() + '/AnalysisItem/AddLossFile', ServiceLibrary.ContentType.JSON, parameters, analysisID);
  }

  UpdateAnalysisItemLossFile(analysisID: number, analysisItemID: number, LossFileID: number, ConversionCurrencyID: number, ConversionRate: number, UseAdjustments: boolean, MaintainAdjustments: boolean = false) {
    const parameters = new Dictionary([]);
    parameters.add('LossFileID', LossFileID);
    parameters.add('ConversionCurrencyID', ConversionCurrencyID);
    parameters.add('ConversionRate', ConversionRate);
    parameters.add('UseAdjustments', UseAdjustments);
    parameters.add('MaintainAdjustments', MaintainAdjustments);

    return this.servLib.HttpPost('/v1/api/AnalysisInternal/' + analysisID.toString() + '/AnalysisItem/' + analysisItemID + '/UpdateLossFile', ServiceLibrary.ContentType.JSON, parameters, analysisID);
  }

  BulkUpdateAnalysisItemUseAdjustments(analysisID: number, analysisItemIDList: number[], UseAdjustments: boolean) {
    const parameters = new Dictionary([]);
    parameters.add('AnalysisItemIDs', analysisItemIDList);
    parameters.add('UseAdjustments', UseAdjustments);

    return this.servLib.HttpPost('/v1/api/AnalysisInternal/' + analysisID.toString() + '/AnalysisItem/BulkUpdateLossFileAdjustment', ServiceLibrary.ContentType.JSON, parameters, analysisID);
  }

  UpdateDisplayOrder(id: number, items: any, systemGenerated: boolean) {
    const parameters = new Dictionary([]);
    parameters.add('items', items);
    parameters.add('systemGenerated', systemGenerated);

    return this.servLib.HttpPost('/v1/api/AnalysisInternal/' + id.toString() + '/AnalysisItem/UpdateDisplayOrder', ServiceLibrary.ContentType.JSON, parameters, id);
  }

  AddLayers(id: number, countToAdd: number) {
    const parameters = new Dictionary([]);
    parameters.add('CountToAdd', countToAdd);

    return this.servLib.HttpPost('/v1/api/Analysis/' + id.toString() + '/Layer/Add', ServiceLibrary.ContentType.JSON, parameters, id);
  }

  AddGroups(id: number, countToAdd: number) {
    const parameters = new Dictionary([]);
    parameters.add('CountToAdd', countToAdd);

    return this.servLib.HttpPost('/v1/api/Analysis/' + id.toString() + '/Group/Add', ServiceLibrary.ContentType.JSON, parameters, id);
  }

  AddAggregators(id: number, countToAdd: number) {
    const parameters = new Dictionary([]);
    parameters.add('CountToAdd', countToAdd);

    return this.servLib.HttpPost('/v1/api/Analysis/' + id.toString() + '/Aggregator/Add', ServiceLibrary.ContentType.JSON, parameters, id);
  }

  AddQuotaShares(id: number, countToAdd: number) {
    const parameters = new Dictionary([]);
    parameters.add('CountToAdd', countToAdd);

    return this.servLib.HttpPost('/v1/api/Analysis/' + id.toString() + '/QuotaShare/Add', ServiceLibrary.ContentType.JSON, parameters, id);
  }

  AnalysisItemSave(id: number, item: any) {
    const parameters = new Dictionary([]);
    parameters.add('AnalysisID', id);
    parameters.add('item', item);
    //console.log('item', item);

    return this.servLib.HttpPost('/v1/api/AnalysisInternal/AnalysisItem/Update', ServiceLibrary.ContentType.JSON, parameters, id);
  }

  AnalysisItemUpload(id: number, updateText: string) {
    const parameters = new Dictionary([]);
    parameters.add('updateText', updateText);

    return this.servLib.HttpPost('/v1/api/AnalysisInternal/' + id + '/AnalysisItemUpload', ServiceLibrary.ContentType.JSON, parameters, id);
  }

  AnalysisItemUpdateAdditionalPremium(id: number, aiid: number, item: any, itemNumber: number) {
    const parameters = new Dictionary([]);
    parameters.add('AnalysisID', id);
    parameters.add('AnalysisItemID', aiid);
    parameters.add('Item', item);
    parameters.add('bandNum', itemNumber);

    return this.servLib.HttpPost('/v1/api/AnalysisInternal/AnalysisItem/UpdateAdditionalPremium', ServiceLibrary.ContentType.JSON, parameters, id);
  }

  AnalysisItemUpdateProfitCommission(id: number, aiid: number, item: any, itemNumber: number) {
    const parameters = new Dictionary([]);
    parameters.add('AnalysisID', id);
    parameters.add('AnalysisItemID', aiid);
    parameters.add('item', item);
    parameters.add('bandNum', itemNumber);

    return this.servLib.HttpPost('/v1/api/AnalysisInternal/AnalysisItem/UpdateProfitCommission', ServiceLibrary.ContentType.JSON, parameters, id);
  }

  AnalysisItemUpdateCedingCommission(id: number, aiid: number, item: any, itemNumber: number) {
    const parameters = new Dictionary([]);
    parameters.add('AnalysisID', id);
    parameters.add('AnalysisItemID', aiid);
    parameters.add('item', item);
    parameters.add('bandNum', itemNumber);

    return this.servLib.HttpPost('/v1/api/AnalysisInternal/AnalysisItem/UpdateCedingCommission', ServiceLibrary.ContentType.JSON, parameters, id);
  }

  GenerateLayerDownloadToken(id: number) {
    const parameters = new Dictionary([]);

    return this.servLib.HttpGet('/v1/api/AnalysisInternal/' + id + '/GenerateLayerDownloadToken', ServiceLibrary.ContentType.JSON, parameters, id);
  }

  DeleteAnalysisParameter(id: number, analysisItemID: number, analysisParameterSetID: number) {
    const parameters = new Dictionary([]);
    parameters.add('AnalysisID', id);
    parameters.add('AnalysisItemID', analysisItemID);
    parameters.add('AnalysisParameterSetID', analysisParameterSetID);

    return this.servLib.HttpPost('/v1/api/AnalysisInternal/AnalysisItem/DeleteParameter', ServiceLibrary.ContentType.JSON, parameters, id);
  }

  GetAnalysisSearchFilterInceptionAndExpiration() {
    // don't need any params
    const parameters = new Dictionary([]);

    return this.servLib.HttpGet('/v1/api/AnalysisInternal/AnalysisSearchFilterInceptionAndExpiration', ServiceLibrary.ContentType.JSON, parameters);
  }

  CopyAnalysis(id: number, name: string, folderID: number) {
    const parameters = new Dictionary([]);
    parameters.add('NewAnalysisName', name);
    parameters.add('NewFolderID', folderID);
    return this.servLib.HttpPost('/v1/api/AnalysisInternal/' + id + '/copy', ServiceLibrary.ContentType.JSON, parameters, id);
  }


  MoveAnalysis(id: number, name: string, folderID: number) {
    const parameters = new Dictionary([]);
    parameters.add('NewAnalysisName', name);
    parameters.add('NewFolderID', folderID);
    return this.servLib.HttpPost('/v1/api/AnalysisInternal/' + id + '/move', ServiceLibrary.ContentType.JSON, parameters, id);
  }

  CopyMultipleAnalysis(id: number[]) {
    const parameters = new Dictionary([]);
    parameters.add('AnalysisIDs', id);
    return this.servLib.HttpPost('/v1/api/AnalysisInternal/copyMultiple', ServiceLibrary.ContentType.JSON, parameters, id.join(','));
  }

  GetAnalysisOwners() {
    // don't need any params
    const parameters = new Dictionary([]);

    return this.servLib.HttpGet('/v1/api/AnalysisInternal/GetAnalysisOwners', ServiceLibrary.ContentType.JSON, parameters);
  }

  TagSearch(searchTerms: string) {
    const parameters = new Dictionary([]);
    parameters.add('SearchTerms', searchTerms);

    return this.servLib.HttpPost('/v1/api/AnalysisInternal/Tags/Search', ServiceLibrary.ContentType.JSON, parameters);
  }

  GetAnalysisTags(id: number) {
    const parameters = new Dictionary([]);

    return this.servLib.HttpGet('/v1/api/AnalysisInternal/' + id + '/Tags', ServiceLibrary.ContentType.JSON, parameters);
  }

  DeleteAnalysis(ids: number[]) {
    const parameters = new Dictionary([]);
    parameters.add('AnalysisIDs', ids);

    return this.servLib.HttpPost('/v1/api/AnalysisInternal/DeleteMultiple', ServiceLibrary.ContentType.JSON, parameters, ids.join(','));
  }

  ArchiveAnalysis(ids: number[]) {
    const parameters = new Dictionary([]);
    parameters.add('AnalysisIDs', ids);

    return this.servLib.HttpPost('/v1/api/AnalysisInternal/Archive', ServiceLibrary.ContentType.JSON, parameters, ids.join(','));
  }

  UnArchiveAnalysis(ids: number[]) {
    const parameters = new Dictionary([]);
    parameters.add('AnalysisIDs', ids);

    return this.servLib.HttpPost('/v1/api/AnalysisInternal/UnArchive', ServiceLibrary.ContentType.JSON, parameters, ids.join(','));
  }

  GetAnalysisDropDownItems(): Observable<ServiceReturn> {
    const parameters = new Dictionary([]);

    return this.servLib.HttpGet('/v1/api/AnalysisInternal/GetAnalysisDropDownItems', ServiceLibrary.ContentType.JSON, parameters);
  }

  UpdateAnalysis(analysisID: number, name: string, descrption: string, inceptionDate: string, expirationDate: string,
                 IsLocked: boolean, CurrencyID: number, ClientID: number, CategoryID: number, ClassID: number,
                 ExposureRegionID: number, StatusID: number, LossSortingMethodID: number, AllocationMethodID: number,
                 Brokerage: number, RIBrokerage: number, Taxes: number, folderID: number, bulkUpdateLayers: boolean, retroPortfolioID: number, ELTAnalysisProcessing: boolean) {
    const parameters = new Dictionary([]);
    parameters.add('Name', name);
    parameters.add('Description', descrption);
    parameters.add('InceptionDate', inceptionDate);
    parameters.add('ExpirationDate', expirationDate);
    parameters.add('IsLocked', IsLocked);
    parameters.add('CurrencyID', CurrencyID);
    parameters.add('ClientID', ClientID);
    parameters.add('CategoryID', CategoryID);
    parameters.add('ClassID', ClassID);
    parameters.add('ExposureRegionID', ExposureRegionID);
    parameters.add('StatusID', StatusID);
    parameters.add('LossSortingMethodID', LossSortingMethodID);
    parameters.add('AllocationMethodID', AllocationMethodID);
    parameters.add('Brokerage', Brokerage);
    parameters.add('RIBrokerage', RIBrokerage);
    parameters.add('Taxes', Taxes);
    parameters.add('FolderID', folderID);
    parameters.add('BulkUpdateLayers', bulkUpdateLayers);
    parameters.add('RetroPortfolioID', retroPortfolioID);
    parameters.add('ELTAnalysisProcessing', ELTAnalysisProcessing);
    return this.servLib.HttpPost('/v1/api/AnalysisInternal/' + analysisID + '/update', ServiceLibrary.ContentType.JSON, parameters);
  }

  UpdateAnalysisTags(analysisID: number, tags: string) {
    const parameters = new Dictionary([]);
    parameters.add('Tags', tags);

    return this.servLib.HttpPost('/v1/api/AnalysisInternal/' + analysisID + '/UpdateTags', ServiceLibrary.ContentType.JSON, parameters);
  }

  InsertNote(id: number, noteText: string) {
    const parameters = new Dictionary([]);
    parameters.add('NoteText', noteText);
    return this.servLib.HttpPost('/v1/api/AnalysisInternal/' + id + '/InsertNote', ServiceLibrary.ContentType.JSON, parameters, id);
  }

  UpdateNote(id: number, noteText: string, noteId: number) {
    const parameters = new Dictionary([]);
    parameters.add('NoteID', noteId);
    parameters.add('NoteText', noteText);
    return this.servLib.HttpPost('/v1/api/AnalysisInternal/' + id + '/UpdateNote', ServiceLibrary.ContentType.JSON, parameters, id);
  }

  DeleteNoteByID(id: number, noteId: number) {
    // don't need any params
    const parameters = new Dictionary([]);
    parameters.add('NoteID', noteId);

    return this.servLib.HttpPost('/v1/api/AnalysisInternal/' + id + '/DeleteNote', ServiceLibrary.ContentType.JSON, parameters, id);
  }

  PollProcessStatuses(ids: number[]) {
    const parameters = new Dictionary([]);
    parameters.add('IdList', ids);

    return this.servLib.HttpPostPolling('/v1/api/AnalysisInternal/PollProcessStatuses', ServiceLibrary.ContentType.JSON, parameters);
  }


  InsertAnalysis(name: string, description: string, inceptionDate: string, expirationDate: string,
                 IsLocked: boolean, CurrencyID: number, ClientID: number, CategoryID: number, ClassID: number,
                 ExposureRegionID: number, StatusID: number, LossSortingMethodID: number, AllocationMethodID: number,
                 Brokerage: number, RIBrokerage: number, Taxes: number, Tags: string, folderID: number, retroPortfolioID: number, currencyRateAttrID: number, ELTAnalysisProcessing: boolean) {
    const parameters = new Dictionary([]);
    parameters.add('Name', name);
    parameters.add('Description', description);
    parameters.add('InceptionDate', inceptionDate);
    parameters.add('ExpirationDate', expirationDate);
    parameters.add('IsLocked', IsLocked);
    parameters.add('CurrencyID', CurrencyID);
    parameters.add('ClientID', ClientID);
    parameters.add('CategoryID', CategoryID);
    parameters.add('ClassID', ClassID);
    parameters.add('ExposureRegionID', ExposureRegionID);
    parameters.add('StatusID', StatusID);
    parameters.add('LossSortingMethodID', LossSortingMethodID);
    parameters.add('AllocationMethodID', AllocationMethodID);
    parameters.add('Brokerage', Brokerage);
    parameters.add('RIBrokerage', RIBrokerage);
    parameters.add('Taxes', Taxes);
    parameters.add('Tags', Tags);
    parameters.add('FolderID', folderID);
    parameters.add('RetroPortfolioID', retroPortfolioID);
    parameters.add('CurrencyRateAttrID', currencyRateAttrID);
    parameters.add('ELTAnalysisProcessing', ELTAnalysisProcessing);
    return this.servLib.HttpPost('/v1/api/AnalysisInternal/Insert', ServiceLibrary.ContentType.JSON, parameters);
  }

  GetNotes(id: number): Observable<ServiceReturn> {
    // don't need any params
    const parameters = new Dictionary([]);

    return this.servLib.HttpGet('/v1/api/AnalysisInternal/' + id + '/notes', ServiceLibrary.ContentType.JSON, parameters, id);
  }

  ProcessAnalysisBulkUpdate(FileDetails: any) {
    const parameters: Dictionary = new Dictionary([]);

    parameters.add('FileDetails', FileDetails);

    return this.servLib.HttpPost('/v1/api/AnalysisInternal/ProcessAnalysisBulkUpdate', ServiceLibrary.ContentType.JSON, parameters);
  }

  ShareAnalysis(AnalysisID: number, ChildCompanyIDs: number[]) {
    const parameters = new Dictionary([]);
    parameters.add('ChildCompanyIDs', ChildCompanyIDs);

    return this.servLib.HttpPost('/v1/api/AnalysisInternal/' + AnalysisID + '/ShareAnalysis', ServiceLibrary.ContentType.JSON, parameters, AnalysisID);
  }

  UpdateFinalized(AnalysisID: number, isFinalized: boolean) {
    const parameters = new Dictionary([]);
    parameters.add('isFinalized', isFinalized);

    return this.servLib.HttpPost('/v1/api/AnalysisInternal/' + AnalysisID + '/UpdateFinalized', ServiceLibrary.ContentType.JSON, parameters, AnalysisID);
  }

  GetAnalysisDefaults(): Observable<ServiceReturn> {
    // don't need any params
    const parameters = new Dictionary([]);

    return this.servLib.HttpGet('/v1/api/AnalysisInternal/GetAnalysisDefaults', ServiceLibrary.ContentType.JSON, parameters);
  }

  GetAnalysisReports(): Observable<ServiceReturn> {
    // don't need any params
    const parameters = new Dictionary([]);

    return this.servLib.HttpGet('/v1/api/AnalysisInternal/AnalysisReports', ServiceLibrary.ContentType.JSON, parameters);
  }

  ProcessButtonValidation(AnalysisID: number) {
      const parameters = new Dictionary([]);

      return this.servLib.HttpGet('/v1/api/AnalysisInternal/' + AnalysisID + '/ProcessButtonValidation', ServiceLibrary.ContentType.JSON, parameters);
  }

  ProcessAnalysis(AnalysisID: number): Observable<ServiceReturn> {
    // don't need any params
    const parameters = new Dictionary([]);

    return this.servLib.HttpPost('/v1/api/AnalysisInternal/' + AnalysisID + '/DoProcess', ServiceLibrary.ContentType.JSON, parameters);
  }

  ProcessAnalysisWithExports(AnalysisID: number, Exports: any, matrixOption: number): Observable<ServiceReturn> {
    // don't need any params
    const parameters = new Dictionary([]);
    parameters.add('Exports', Exports);
    parameters.add('MatrixOption', matrixOption);
    return this.servLib.HttpPost('/v1/api/AnalysisInternal/' + AnalysisID + '/DoProcessWithExports', ServiceLibrary.ContentType.JSON, parameters);
  }

  PrepAnalysisItemsWithExports(AnalysisID: number, PrepItems: any, Exports: any): Observable<ServiceReturn> {
    // don't need any params
    const parameters = new Dictionary([]);
    parameters.add('Exports', Exports);
    parameters.add('PrepItems', PrepItems);
    return this.servLib.HttpPost('/v1/api/AnalysisInternal/' + AnalysisID + '/PrepAnalysisItemsWithExports', ServiceLibrary.ContentType.JSON, parameters);
  }

  GetLossAndEltDetails(AnalysisID: number): Observable<ServiceReturn> {
    // don't need any params
    const parameters = new Dictionary([]);

    return this.servLib.HttpGet('/v1/api/AnalysisInternal/' + AnalysisID + '/LossAndEltDetails', ServiceLibrary.ContentType.JSON, parameters);
  }

  InsertCCRM(AnalysisID: number, OrderRank: number) {
    const parameters = new Dictionary([]);
    parameters.add('orderRank', OrderRank);

    return this.servLib.HttpPost('/v1/api/AnalysisInternal/' + AnalysisID + '/InsertCCRM', ServiceLibrary.ContentType.JSON, parameters, AnalysisID);
  }

  UpdateCCRM(AnalysisID: number, AnalysisCCRMID: number, ItemID: number, Lower: number, Upper: number, WTL: number, OrderRank: number) {
    const parameters = new Dictionary([]);
    parameters.add('itemID', ItemID);
    parameters.add('lowerPercentile', Lower);
    parameters.add('upperPercentile', Upper);
    parameters.add('wTL', WTL);
    parameters.add('orderRank', OrderRank);

    return this.servLib.HttpPost('/v1/api/AnalysisInternal/' + AnalysisID + '/' + AnalysisCCRMID + '/UpdateCCRM', ServiceLibrary.ContentType.JSON, parameters, AnalysisID);
  }

  DeleteCCRM(AnalysisID: number, AnalysisCCRMID: number) {
    const parameters = new Dictionary([]);

    return this.servLib.HttpDelete('/v1/api/AnalysisInternal/' + AnalysisID + '/' + AnalysisCCRMID + '/DeleteCCRM', ServiceLibrary.ContentType.JSON, parameters, AnalysisID);
  }

  GetReturnPeriods(AnalysisID: number) {
    const parameters = new Dictionary([]);

    return this.servLib.HttpGet('/v1/api/AnalysisInternal/' + AnalysisID + '/ReturnPeriods', ServiceLibrary.ContentType.JSON, parameters, AnalysisID);
  }

  UpdateReturnPeriods(AnalysisID: number, ReturnPeriods: any) {
    const parameters = new Dictionary([]);
    parameters.add('ReturnPeriodList', ReturnPeriods);
    return this.servLib.HttpPost('/v1/api/AnalysisInternal/' + AnalysisID + '/UpdateReturnPeriods', ServiceLibrary.ContentType.JSON, parameters, AnalysisID);
  }

  GetReportOptions(AnalysisID: number) {
    const parameters = new Dictionary([]);

    return this.servLib.HttpGet('/v1/api/AnalysisInternal/' + AnalysisID + '/ReportOptions', ServiceLibrary.ContentType.JSON, parameters, AnalysisID);
  }

  UpdateReportOptions(AnalysisID: number, ReportOptions: any) {
    const parameters = new Dictionary([]);
    parameters.add('ReportOptions', ReportOptions);
    return this.servLib.HttpPost('/v1/api/AnalysisInternal/' + AnalysisID + '/UpdateReportOptions', ServiceLibrary.ContentType.JSON, parameters, AnalysisID);
  }

  ProcessBulkAnalysisImport(fileID: string) {
    const parameters = new Dictionary([]);
    parameters.add('fileID', fileID);
    return this.servLib.HttpPost('/v1/api/AnalysisInternal/ProcessBulkAnalysisImport', ServiceLibrary.ContentType.JSON, parameters);
  }

  GetRelationshipLossFileItems(analysisID: number) {
    const parameters = new Dictionary([]);
    return this.servLib.HttpGet('/v1/api/AnalysisInternal/' + analysisID + '/GetRelationshipLossFileItems', ServiceLibrary.ContentType.JSON, parameters, analysisID);
  }

  GetRelationshipData(analysisID: number) {
    const parameters = new Dictionary([]);
    return this.servLib.HttpGet('/v1/api/AnalysisInternal/' + analysisID + '/GetRelationshipData', ServiceLibrary.ContentType.JSON, parameters, analysisID);
  }

  AddRelationship(analysisID: number, itemRef: number, layerTypeID: number, childRefs: any, childTypes: any) {
    const parameters = new Dictionary([]);
    parameters.add('AnalysisID', analysisID);
    parameters.add('ParentRef', itemRef);
    parameters.add('ParentTypeID', layerTypeID);
    parameters.add('ChildRefs', childRefs);
    parameters.add('ChildTypeIDs', childTypes);

    return this.servLib.HttpPost('/v1/api/AnalysisInternal/AddRelationship', ServiceLibrary.ContentType.JSON, parameters, analysisID);
  }

  DeleteRelationship(analysisID: number, analysisXItemID: number) {
    const parameters = new Dictionary([]);
    parameters.add('AnalysisID', analysisID);
    parameters.add('AnalysisXItemID', analysisXItemID);

    return this.servLib.HttpPost('/v1/api/AnalysisInternal/DeleteRelationship', ServiceLibrary.ContentType.JSON, parameters, analysisID);
  }


  DeleteRelationshipByItemRef(analysisID: number, itemRefID: number) {
    const parameters = new Dictionary([]);

    return this.servLib.HttpPost('/v1/api/AnalysisInternal/' + analysisID + '/DeleteRelationshipsByRefID/' + itemRefID, ServiceLibrary.ContentType.JSON, parameters, analysisID);
  }


  DeleteRelationshipByAnaysisID(analysisID: number) {
    const parameters = new Dictionary([]);

    return this.servLib.HttpPost('/v1/api/AnalysisInternal/' + analysisID + '/DeleteRelationshipsByAnalysis', ServiceLibrary.ContentType.JSON, parameters, analysisID);
  }

  UpdateRelationship(analysisID: number, analysisXItemID: number, lossType: number, peril: string, region: string, lob: string, multiplier: number, parentRef: number, childRef: number, sourceID: string) {
    const parameters = new Dictionary([]);
    parameters.add('AnalysisID', analysisID);
    parameters.add('AnalysisXItemID', analysisXItemID);
    parameters.add('LossType', lossType);
    parameters.add('Peril', peril);
    parameters.add('Region', region);
    parameters.add('LoB', lob);
    parameters.add('Multiplier', multiplier);
    parameters.add('ParentRef', parentRef);
    parameters.add('ChildRef', childRef);
    parameters.add('SourceID', sourceID);
    
    return this.servLib.HttpPost('/v1/api/AnalysisInternal/UpdateRelationship', ServiceLibrary.ContentType.JSON, parameters, analysisID);
  }

  UpdateAnalysisFilter(analysisID: number, validateFilter: boolean) {
    const parameters = new Dictionary([]);
    parameters.add('AnalysisID', analysisID);
    parameters.add('ValidateFilters', validateFilter);

    return this.servLib.HttpPost('/v1/api/AnalysisInternal/UpdateAnalysisFilter', ServiceLibrary.ContentType.JSON, parameters, analysisID);
  }

  ShouldValidateFilters(analysisID: number) {
    const parameters = new Dictionary([]);

    return this.servLib.HttpGet('/v1/api/AnalysisInternal/' + analysisID + '/ShouldValidateFilters', ServiceLibrary.ContentType.JSON, parameters, analysisID);
  }
  

  ProcessAnalysisLossAttrDistributions(lossFileIDs: number[], AnalysisID: number) {
    const parameters = new Dictionary([]);
    parameters.add('LossFileIDList', lossFileIDs);
    return this.servLib.HttpPost('/v1/api/AnalysisInternal/' + AnalysisID + '/ProcessAnalysisLossAttrDistributions', ServiceLibrary.ContentType.JSON, parameters, AnalysisID);
  }

  GetDeterministicTrials(id: number) {
    const parameters = new Dictionary([]);
    return this.servLib.HttpGet('/v1/api/AnalysisInternal/' + id + '/Deterministic', ServiceLibrary.ContentType.JSON, parameters, id);
  }

  AllowDeterministicTrials(id: number) {
    const parameters = new Dictionary([]);
    return this.servLib.HttpGet('/v1/api/AnalysisInternal/' + id + '/Deterministic/AllowInsertTrial', ServiceLibrary.ContentType.JSON, parameters, id);
  }

  InsertDeterministicTrial(id: number) {
    const parameters = new Dictionary([]);
    return this.servLib.HttpGet('/v1/api/AnalysisInternal/' + id + '/Deterministic/InsertTrial', ServiceLibrary.ContentType.JSON, parameters, id);
  }

  UpdateDeterministicTrial(id: number, trialID: number, name: string) {
    const parameters = new Dictionary([]);
    parameters.add('AnalysisDeterministicLossAttrID', trialID);
    parameters.add('Name', name);
    return this.servLib.HttpPost('/v1/api/AnalysisInternal/' + id + '/Deterministic/UpdateTrial', ServiceLibrary.ContentType.JSON, parameters, id);
  }

  DeleteDeterministicTrial(id: number, trialID: number) {
    const parameters = new Dictionary([]);
    parameters.add('AnalysisDeterministicLossAttrID', trialID);
    return this.servLib.HttpPost('/v1/api/AnalysisInternal/' + id + '/Deterministic/DeleteTrial', ServiceLibrary.ContentType.JSON, parameters, id);
  }

  InsertDeterministicLoss(id: number, trialID) {
    const parameters = new Dictionary([]);
    parameters.add('AnalysisDeterministicLossAttrID', trialID);
    return this.servLib.HttpPost('/v1/api/AnalysisInternal/' + id + '/Deterministic/InsertLoss', ServiceLibrary.ContentType.JSON, parameters, id);
  }

  UpdateDeterministicLoss(id: number, trialID: number, lossID: number, subjectItemRef: number, dayOfYear: number, eventID: number, loss: number, perilID: number, region: string, lineOfBusiness: string) {
    const parameters = new Dictionary([]);
    parameters.add('AnalysisDeterministicLossAttrID', trialID);
    parameters.add('AnalysisDeterministicLossID', lossID);
    parameters.add('SubjectItemRef', subjectItemRef);
    parameters.add('DayOfYear', dayOfYear);
    parameters.add('EventID', eventID);
    parameters.add('Loss', loss);
    parameters.add('PerilID', perilID);
    parameters.add('Region', region);
    parameters.add('LineOfBusiness', lineOfBusiness);
    return this.servLib.HttpPost('/v1/api/AnalysisInternal/' + id + '/Deterministic/UpdateLoss', ServiceLibrary.ContentType.JSON, parameters, id);
  }

  DeleteDeterministicLoss(id: number, trialID: number, lossID: number) {
    const parameters = new Dictionary([]);
    parameters.add('AnalysisDeterministicLossAttrID', trialID);
    parameters.add('AnalysisDeterministicLossID', lossID);
    return this.servLib.HttpPost('/v1/api/AnalysisInternal/' + id + '/Deterministic/DeleteLoss', ServiceLibrary.ContentType.JSON, parameters, id);
  }

  GenerateDeterministicDownloadToken(id: number, lossTypes: any, aiids: any) {
    const parameters = new Dictionary([]);
    parameters.add('LossTypes', lossTypes);
    parameters.add('AnalysisItemIDs', aiids);

    return this.servLib.HttpPost('/v1/api/AnalysisInternal/' + id + '/GenerateDeterministicDownloadToken', ServiceLibrary.ContentType.JSON, parameters, id);
  }

  GenerateDeterministicDelayedDownload(id: number, lossTypes: any, aiids: any) {
    const parameters = new Dictionary([]);
    parameters.add('LossTypes', lossTypes);
    parameters.add('AnalysisItemIDs', aiids);

    return this.servLib.HttpPost('/v1/api/AnalysisInternal/' + id + '/GenerateDeterministicDelayedDownload', ServiceLibrary.ContentType.JSON, parameters, id);
  }

  ImportDeterministicLoss(id: number, importData: any) {
    const parameters = new Dictionary([]);
    parameters.add('trials', importData);
    return this.servLib.HttpPost('/v1/api/AnalysisInternal/' + id + '/Deterministic/Import', ServiceLibrary.ContentType.JSON, parameters, id);
  }

  GetLastInstance(id: number) {
    const parameters = new Dictionary([]);
    return this.servLib.HttpGet('/v1/api/AnalysisInternal/' + id + '/GetLastInstance', ServiceLibrary.ContentType.JSON, parameters, id);
  }

  GetLastInstanceStatus(id: number) {
    const parameters = new Dictionary([]);
    return this.servLib.HttpGetPolling('/v1/api/AnalysisInternal/' + id + '/GetLastInstanceStatus', ServiceLibrary.ContentType.JSON, parameters, id);
  }

  GetInstance(id: number, aiid: number) {
    const parameters = new Dictionary([]);
    return this.servLib.HttpGet('/v1/api/AnalysisInternal/' + id + '/GetInstance/' + aiid, ServiceLibrary.ContentType.JSON, parameters, id);
  }

  CreateLossFilesFromInstance(id: number, aiid: number, items: any[]) {
    const parameters = new Dictionary([]);
    parameters.add('lossFiles', items);
    return this.servLib.HttpPost('/v1/api/AnalysisInternal/' + id + '/CreateLossFiles/' + aiid, ServiceLibrary.ContentType.JSON, parameters, id);
  }

  GenerateReportDownloadToken(id: number, aiid: number, reportType: string) {
    const parameters = new Dictionary([]);
    return this.servLib.HttpGet('/v1/api/AnalysisInternal/' + id + '/GenerateReportDownloadToken/' + aiid + '/' + reportType, ServiceLibrary.ContentType.JSON, parameters, id);
  }

  GetAnalysisInstanceReport(id: number, aiid: number, reportId: number) {
    const parameters = new Dictionary([]);
    return this.servLib.HttpGet('/v1/api/AnalysisInternal/' + id + '/GetAnalysisInstanceReport/' + aiid + '/' + reportId, ServiceLibrary.ContentType.JSON, parameters, id);
  }

  GetAnalysisLRPReportCombinations() {
    const parameters = new Dictionary([]);
    return this.servLib.HttpGet('/v1/api/AnalysisInternal/GetAnalysisLRPReportCombinations', ServiceLibrary.ContentType.JSON, parameters);
  }

  UpdateAnalysisLRPReportCombination(AnalysisLRPReportCombinationID: number, Name: string, Description: string, IsActive: boolean) {
    const parameters = new Dictionary([]);
    parameters.add('AnalysisLRPReportCombinationID', AnalysisLRPReportCombinationID);
    parameters.add('Name', Name);
    parameters.add('Description', Description);
    parameters.add('IsActive', IsActive);
    return this.servLib.HttpPost('/v1/api/AnalysisInternal/UpdateAnalysisLRPReportCombination', ServiceLibrary.ContentType.JSON, parameters);
  }

  ImportLrpCombination(Name: string, Description: string, newLrpCombinationData: any) {
    const parameters = new Dictionary([]);
    parameters.add('Name', Name);
    parameters.add('Description', Description);
    parameters.add('NewLrpData', newLrpCombinationData);
    return this.servLib.HttpPost('/v1/api/AnalysisInternal/ImportLRPCombination', ServiceLibrary.ContentType.JSON, parameters);
  }

  LRPCombinationExport(AnalysisLRPReportCombinationID: number) {
    const parameters = new Dictionary([]);
    parameters.add('AnalysisLRPReportCombinationID', AnalysisLRPReportCombinationID);
    return this.servLib.HttpPost('/v1/api/AnalysisInternal/GenerateLRPCombinationExportToken', ServiceLibrary.ContentType.JSON, parameters);
  }

  UpdateProcessMarginal(AnalysisID: number, LossAttrID: number, LossAttrPeril: string, LossAttrRegion: string, LossAttrLOB: string,
                        PortfolioID: number, UseAdjustments: boolean, IncludeCeded: boolean, PortfolioPeril: string,
                        PortfolioRegion: string, PortfolioLOB: string, RMLower: number, RMUpper: number,
                        UsePortfolioIDForMarginal: boolean, ExcludeAnalysisItemIDList: string, MarginalPortfolioPerspectiveID: number) {
    const parameters = new Dictionary([]);
    parameters.add('LossAttrID', LossAttrID);
    parameters.add('LossAttrPeril', LossAttrPeril);
    parameters.add('LossAttrRegion', LossAttrRegion);
    parameters.add('LossAttrLOB', LossAttrLOB);
    parameters.add('PortfolioID', PortfolioID);
    parameters.add('UseAdjustments', UseAdjustments);
    parameters.add('IncludeCeded', IncludeCeded);
    parameters.add('PortfolioPeril', PortfolioPeril);
    parameters.add('PortfolioRegion', PortfolioRegion);
    parameters.add('PortfolioLOB', PortfolioLOB);
    parameters.add('RMLower', RMLower);
    parameters.add('RMUpper', RMUpper);
    parameters.add('UsePortfolioIDForMarginal', UsePortfolioIDForMarginal);
    parameters.add('ExcludeAnalysisItemIDList', ExcludeAnalysisItemIDList);
    parameters.add('MarginalPortfolioPerspectiveID', MarginalPortfolioPerspectiveID);

    return this.servLib.HttpPost('/v1/api/AnalysisInternal/' + AnalysisID + '/UpdateProcessMarginalDetails', ServiceLibrary.ContentType.JSON, parameters);
  }

  GetMarginalExcludeItems(AnalysisID: number) {
    const parameters = new Dictionary([]);

    return this.servLib.HttpGet('/v1/api/AnalysisInternal/' + AnalysisID + '/GetMarginalExcludeItems', ServiceLibrary.ContentType.JSON, parameters);
  }

  CheckAnalysisMarginalItems(AnalysisID: number, PortfolioID: number, LossAttrID: number){
    const parameters = new Dictionary([]);
    parameters.add('LossAttrID', LossAttrID);
    parameters.add('PortfolioID', PortfolioID);

    return this.servLib.HttpPost('/v1/api/AnalysisInternal/' + AnalysisID + '/AnalysisMarginalItemCheck', ServiceLibrary.ContentType.JSON, parameters);
  }

  GetAnalysisInstances(id: number) {
    const parameters = new Dictionary([]);
    return this.servLib.HttpGet('/v1/api/AnalysisInternal/' + id + '/AnalysisInstances', ServiceLibrary.ContentType.JSON, parameters, id);
  }

  RequeueAnalysisInstances(AnalysisID: number, AnalysisInstanceIDs: any) {
    const parameters = new Dictionary([]);
    parameters.add('AnalysisInstanceIDs', AnalysisInstanceIDs);

    return this.servLib.HttpPost('/v1/api/AnalysisInternal/' + AnalysisID + '/AnalysisInstances/Requeue', ServiceLibrary.ContentType.JSON, parameters);
  }

  DeleteAnalysisInstances(AnalysisID: number, AnalysisInstanceIDs: any) {
    const parameters = new Dictionary([]);
    parameters.add('AnalysisInstanceIDs', AnalysisInstanceIDs);

    return this.servLib.HttpPost('/v1/api/AnalysisInternal/' + AnalysisID + '/AnalysisInstances/Delete', ServiceLibrary.ContentType.JSON, parameters);
  }

  UpdateAnalysisInstanceDescription(AnalysisID: number, AnalysisInstanceID: number, Description: string) {
    const parameters = new Dictionary([]);
    parameters.add('Description', Description);

    return this.servLib.HttpPost('/v1/api/AnalysisInternal/' + AnalysisID + '/AnalysisInstance/' + AnalysisInstanceID + '/UpdateDescription', ServiceLibrary.ContentType.JSON, parameters);
  }


  //#region Retro

  GetRetroLossesByAnalysisID(AnalysisID: number): Observable<RetroAnalysisLoss[]> {
    const parameters = new Dictionary([]);
    return this.servLib.HttpGet('/v1/api/AnalysisInternal/' + AnalysisID + '/Losses', ServiceLibrary.ContentType.JSON, parameters, AnalysisID)
    .pipe(map((res: any) => res.json.data));
  }

    GetRetroLossesToAddByAnalysisID(AnalysisID: number): Observable<RetroAnalysisLoss[]> {
      const parameters = new Dictionary([]);
      return this.servLib.HttpGet('/v1/api/AnalysisInternal/' + AnalysisID + '/LossesToAdd', ServiceLibrary.ContentType.JSON, parameters, AnalysisID)
      .pipe(map((res: any) => res.json.data));
    }

    AddRetroLossToAnalysis(AnalysisID: number, items: AddRetroLoss[]):  Observable<RetroAnalysisLoss[]> {

      const losses = new AddRetroLossParam();
      losses.portfolios = items;

      const parameters = new Dictionary([]);
      parameters.add('Portfolios', items);

      return this.servLib.HttpPost('/v1/api/AnalysisInternal/' + AnalysisID + '/AddLosses', ServiceLibrary.ContentType.JSON, parameters, AnalysisID)
      .pipe(map((res: any) => res.json.data));
    }

    UpdateRetroLossAdjustmentType(AnalysisID: number, PortfolioIDList: number[], useAdjusted: boolean):  Observable<RetroAnalysisLoss[]> {

      const parameters = new Dictionary([]);
      parameters.add('PortfolioIDList', PortfolioIDList);
      parameters.add('UseAdjusted', useAdjusted);

      return this.servLib.HttpPost('/v1/api/AnalysisInternal/' + AnalysisID + '/UpdateRetroLossAdjustmentType', ServiceLibrary.ContentType.JSON, parameters, AnalysisID)
      .pipe(map((res: any) => res.json.data));
    }


    DeleteRetroLossFromAnalysis(AnalysisID: number, items: AddRetroLoss[]):  Observable<RetroAnalysisLoss[]> {

      const losses = new AddRetroLossParam();
      losses.portfolios = items;

      const parameters = new Dictionary([]);
      parameters.add('Portfolios', items);

      return this.servLib.HttpPost('/v1/api/AnalysisInternal/' + AnalysisID + '/RemoveLosses', ServiceLibrary.ContentType.JSON, parameters, AnalysisID)
      .pipe(map((res: any) => res.json.data));
    }

  UpdateIsRetroLayer(AnalysisID: number, AnalysisItemID: number, isRetroLayer: boolean) {
    const parameters = new Dictionary([]);
    parameters.addOrUpdate('IsRetroLayer', isRetroLayer);

    return this.servLib.HttpPost('/v1/api/AnalysisInternal/' + AnalysisID + '/AnalysisItem/' + AnalysisItemID + '/UpdateIsRetroLayer', ServiceLibrary.ContentType.JSON, parameters);
  }

  //#endregion

  GetAnalysisLossAttrProcessingStatuses(AnalysisID: number, lossAttrIDs: number[]) {
    const parameters = new Dictionary([]);
    parameters.add('LossAttrIDs', lossAttrIDs);

    if (lossAttrIDs === undefined || lossAttrIDs.length === 0) {
      return new Observable();
    } else {
      return this.servLib.HttpPostPolling('/v1/api/AnalysisInternal/' + AnalysisID + '/GetAnalysisLossAttrProcessingStatuses', ServiceLibrary.ContentType.JSON, parameters);
    }
  }

  LayerLFProtobufToSQL(AnalysisID: number, AnalysisInstanceID: number, AnalysisItemID: number) {
    const parameters = new Dictionary([]);
    parameters.add('AnalysisID', AnalysisID);
    parameters.add('AnalysisInstanceID', AnalysisInstanceID);
    parameters.add('AnalysisItemID', AnalysisItemID);

    return this.servLib.HttpPost('/v1/api/AnalysisInternal/LayerLFProtobufToSQL', ServiceLibrary.ContentType.JSON, parameters);
  }

  AnalysisItemELTToSQL(AnalysisID: number, AnalysisInstanceID: number, AnalysisItemID: number) {
    const parameters = new Dictionary([]);
    parameters.add('AnalysisID', AnalysisID);
    parameters.add('AnalysisInstanceID', AnalysisInstanceID);
    parameters.add('AnalysisItemID', AnalysisItemID);

    return this.servLib.HttpPost('/v1/api/AnalysisInternal/AnalysisItemELTPBToSQL', ServiceLibrary.ContentType.JSON, parameters);
  }

  GetCurrencyRateSet(AnalysisID: number): Observable<ServiceReturn> {
    const parameters = new Dictionary([]);

    return this.servLib.HttpGet('/v1/api/AnalysisInternal/' + AnalysisID + '/GetCurrencyRateSet', ServiceLibrary.ContentType.JSON, parameters);
  }

  UpdateCurrencyRateSet(AnalysisID: number, CurrencyRateAttrID: number) {
    const parameters = new Dictionary([]);
    parameters.add('CurrencyRateAttrID', CurrencyRateAttrID);
    return this.servLib.HttpPost('/v1/api/AnalysisInternal/' + AnalysisID + '/UpdateCurrencyRateSet', ServiceLibrary.ContentType.JSON, parameters);
  }

  GetNumSimulations (AnalysisID: number, AnalysisInstanceID: number) {
    const parameters = new Dictionary([]);

    return this.servLib.HttpGet('/v1/api/AnalysisInternal/' + AnalysisID + '/GetNumSimulations/' + AnalysisInstanceID, ServiceLibrary.ContentType.JSON, parameters);
  }
  
  GetAnalysesPortfolios(AnalysisIDs: string): Observable<ServiceReturn> {
    const parameters = new Dictionary([]);
    parameters.add('AnalysisIDs', AnalysisIDs);

    return this.servLib.HttpPost('/v1/api/AnalysisInternal/GetAnalysesPortfolios/', ServiceLibrary.ContentType.JSON, parameters);
  }

}